module.exports = __webpack_public_path__ + "img/chris-profile.dc62b409.jpg";